module.exports = __webpack_public_path__ + "static/media/shape1_0.30eaf93b.obj";